import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const WorcesterRedSoxLink = () => (
  <Link
    target="_blank"
    href="https://mlb.tickets.com/?agency=WRXM_MYTIXX&orgid=57632#/auth/login?fullret=%2Fticketmanagement%2F%3Fagency%3DWRXM_MYTIXX%26orgid%3D57632"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
  >
    MyProVenue
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description:
      "Select the games you wish to attend. The more games you select the higher your discount. At 10 games unlock the opportunity to take batting practice at Polar Park!",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com.",
    description:
      "Click Continue and connect your Woosox account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your <WorcesterRedSoxLink /> account within
        24 hours of purchase. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Woosox Pick'em Plan work?",
    description:
      "The Woosox Pick'em Plan allows users to unlock discounts the more games they buy, unlocking a batting practice at Polar Park at 10 games! Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Woosox{" "}
        <WorcesterRedSoxLink /> Account.
      </>
    ),
  },
  {
    title: "How do I get notified about the batting practice opportunity?",
    description:
      "Our box office will be in touch with you prior to season start to share more information about batting practice at Polar Park!",
  },
];
